// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders and matches snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
      >
        <div
          class="MuiBox-root MuiBox-root-1"
        >
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
          >
            <div
              class="MuiBox-root MuiBox-root-2"
            >
              <span
                class="MuiTypography-root MuiTypography-body1"
              >
                Email
              </span>
            </div>
            <div
              class="MuiBox-root MuiBox-root-3"
              style="cursor: pointer;"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                focusable="false"
                style="color: rgb(16, 128, 128);"
                viewBox="0 0 24 24"
              >
                <path
                  d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                />
              </svg>
              <span
                class="MuiBox-root MuiBox-root-4"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  Edit
                </span>
              </span>
            </div>
          </div>
        </div>
        <div
          class="MuiBox-root MuiBox-root-5"
        >
          <div
            class="MuiGrid-root MuiGrid-container"
          >
            <div
              class="MuiBox-root MuiBox-root-6"
            >
              <span
                class="MuiTypography-root MuiTypography-body2"
              >
                user@dr-bill.ca
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthSm"
    >
      <div
        class="MuiBox-root MuiBox-root-1"
      >
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
        >
          <div
            class="MuiBox-root MuiBox-root-2"
          >
            <span
              class="MuiTypography-root MuiTypography-body1"
            >
              Email
            </span>
          </div>
          <div
            class="MuiBox-root MuiBox-root-3"
            style="cursor: pointer;"
          >
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
              focusable="false"
              style="color: rgb(16, 128, 128);"
              viewBox="0 0 24 24"
            >
              <path
                d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
              />
            </svg>
            <span
              class="MuiBox-root MuiBox-root-4"
            >
              <span
                class="MuiTypography-root MuiTypography-body2"
              >
                Edit
              </span>
            </span>
          </div>
        </div>
      </div>
      <div
        class="MuiBox-root MuiBox-root-5"
      >
        <div
          class="MuiGrid-root MuiGrid-container"
        >
          <div
            class="MuiBox-root MuiBox-root-6"
          >
            <span
              class="MuiTypography-root MuiTypography-body2"
            >
              user@dr-bill.ca
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
